angular.module('salesPath2')
  .controller('apkExternalModalCtrl', ['$scope', 'dataContainerHelper', 'sp2UiHelper', 'apkErrorsHelper',
    function($scope, dataContainerHelper, sp2UiHelper, apkErrorsHelper) {

      /**
      * init
      */
      $scope.init = function() {        
        $scope.fireListeners();
      };

      /**
       * Odpalenie watchy
       */
      $scope.fireListeners = function() {
        // continue
        $scope.$on('iHestiaCommonModalOkBtnClicked.apkExternalModal', function() {
          dataContainerHelper.setApk({
            apkNumber: null
          });
        });

        // refresh
        $scope.$on('iHestiaCommonModalCancelBtnClicked.apkExternalModal', function() {
          sp2UiHelper.showBlockUi();
          var apk = dataContainerHelper.getApk();
          apkErrorsHelper.getApkDetails({apkid: apk.apkId});
        });
      };

      $scope.init();

    }
  ]);
